import jsCookie from 'js-cookie';
import {
  getCurrentRefererId,
  removeRefererIdInLocalStorage,
} from './refererManagement';
import { getHttpReferer, removeNullValues } from './utils';

enum Cookies {
  MM_VISITOR_ID = 'mm_visitor_id',
}

export interface RefererServiceResponse {
  refererId: string;
  rawRefererId: string;
  refererCalculationDate: string;
  trackingCampaign: string;
  trackingCategory: string;
  trackingChannel: string;
}

class RefererService {
  manomanoApiUrl: string;

  constructor(manomanoApiUrl: string) {
    this.manomanoApiUrl = manomanoApiUrl;
  }

  private getRefererIdFromQueryString = (): string | null => {
    const pageSearchParams = new URLSearchParams(window.location.search);
    if (pageSearchParams.has('referer_id')) {
      const refererId = pageSearchParams.get('referer_id');
      if (refererId !== null) {
        return Number.isNaN(+refererId) ? null : refererId;
      }
    }

    return null;
  };

  removeInvalidCurrentRefererId = () => {
    const currentRefererId = getCurrentRefererId();
    if (currentRefererId !== null && Number.isNaN(+currentRefererId)) {
      removeRefererIdInLocalStorage();
    }
  };

  getBaseUrl = (): string => `${this.manomanoApiUrl}/api/v1/referer/visitor/`;

  getTrackingInfo(
    pageType: string,
    cookieDisabled: boolean
  ): Promise<RefererServiceResponse> {
    const visitorId = jsCookie.get(Cookies.MM_VISITOR_ID);
    if (!visitorId) {
      throw new Error('No visitor_id found');
    }
    const params = removeNullValues({
      page_type: pageType,
      referer: getHttpReferer(),
      referer_id: this.getRefererIdFromQueryString(),
      current_referer_id: getCurrentRefererId(),
      cookie_disabled: cookieDisabled,
    });

    const queryString = new URLSearchParams(params);
    const url = `${this.getBaseUrl()}${visitorId}${
      queryString ? `?${queryString.toString()}` : ''
    }`;
    return fetch(url, {
      method: 'GET',
      credentials: 'include',
    }).then((res) => {
      if (!res.ok) {
        throw new Error(res.statusText);
      }
      return res.json();
    });
  }
}

export default RefererService;
